import { LinkTabs, useHasPermission } from "@dgs/core";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, Route, Routes } from "react-router";
import { PermissionName } from "../../../shared/types/permission";
import { ContactClippingList } from "../clippings/details/ContactClippingList";
import { ContactEventList } from "../contacts/ContactEventList";
import { ContactViewPage } from "../contacts/view/ContactViewPage";
import { DefaultContentLayout, ViewPageContentLayout } from "../shared/Layout";
import { StyledLinkTab } from "./ContactPage";

export const ContactDetailsNavigation = () => {
	const { t } = useTranslation();
	const canReadEvents = useHasPermission<PermissionName>(["event.read"]);

	return (
		<>
			<LinkTabs>
				<StyledLinkTab to="details">{t("Details")}</StyledLinkTab>
				<StyledLinkTab to="clippings">{t("Clippings")}</StyledLinkTab>
				{canReadEvents && <StyledLinkTab to="events">{t("Events")}</StyledLinkTab>}
			</LinkTabs>
			<Outlet />
		</>
	);
};

export const ContactDetailPages = () => {
	return (
		<>
			<Routes>
				<Route index element={<Navigate to="details" replace />} />
				<Route
					path="details"
					element={
						<ViewPageContentLayout>
							<ContactViewPage />
						</ViewPageContentLayout>
					}
				/>
				<Route
					path="clippings"
					element={
						<DefaultContentLayout>
							<ContactClippingList />
						</DefaultContentLayout>
					}
				/>
				<Route
					path="events"
					element={
						<DefaultContentLayout>
							<ContactEventList />
						</DefaultContentLayout>
					}
				/>
			</Routes>
		</>
	);
};
